import {Stack, Typography, Chip, Box} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {LoginSignupStack} from "../../../navbar";
import {useGetProfileQuery} from "../../../../store/api/userApiSlice";
import ProblemTimerUI from "./ProblemTimerUI";
import ProblemOptionUI, {getOptionStateType} from "./ProblemOptionUI";
import {ProblemType} from "../../../../config/enums";
import {
  ProblemDifficultyType,
  stringToProblemDifficultyType,
} from "../../../../config/enums";
import {difficultyTheme} from "../../../../config/themes/difficulty-theme";
import ProblemTextFieldUI from "./ProblemTextFieldUI";
import AiButtonUI from "./AiButtonUI";
import {IQuestion} from "../../api/parseGetQuestionResponse";
import {STYLES} from "./STYLES";
const HtmlToReactParser = require("html-to-react").Parser;

interface ProblemContentUIProps {
  questionData: IQuestion;
  onUpdateQuestionResponse: (answer: string) => void;
  isSubmitted: boolean;
  onOpenPanel: () => void;
  onSubmitQuestion: () => void;
}
export default function ProblemContentUI({
  questionData,
  onUpdateQuestionResponse,
  isSubmitted,
  onOpenPanel,
  onSubmitQuestion,
}: ProblemContentUIProps) {
  const htmlToReactParser = new HtmlToReactParser();
  const {data: userData} = useGetProfileQuery();

  function UserInputUI() {
    switch (questionData.qType) {
      case ProblemType.SingleCorrect:
        return (
          <Grid container spacing={2}>
            {questionData.options.map((option, index) => (
              <Grid key={option.id} size={6}>
                <ProblemOptionUI
                  type={getOptionStateType(
                    option.id,
                    questionData.userAnswer ?? undefined,
                    questionData.postSubmit?.correctAnswer,
                  )}
                  optionIdx={String.fromCharCode(65 + index)}
                  data={htmlToReactParser.parse(option.description)}
                  onClick={() => {
                    if (isSubmitted) return;
                    onUpdateQuestionResponse(option.id);
                  }}
                />
              </Grid>
            ))}
          </Grid>
        );
      case ProblemType.Numerical:
        return (
          <ProblemTextFieldUI
            status={questionData.status}
            inputValue={questionData.userAnswer ?? ""}
            correctValue={questionData.postSubmit?.correctAnswer}
            onChange={onUpdateQuestionResponse}
            onSubmitQuestion={onSubmitQuestion}
          />
        );
      default:
        return <></>;
    }
  }

  return (
    <Stack sx={STYLES.problemContentContainer}>
      <Box sx={STYLES.problemContentHeaderContainer}>
        <Stack direction={"row"} justifyContent={"space-between"}>
          <Stack direction={"row"} gap={1} alignItems={"center"}>
            {questionData.tags.map(tag => (
              <Chip key={tag.name} label={tag.name} sx={STYLES.problemTags} />
            ))}
            <Chip
              label={stringToProblemDifficultyType(questionData.difficulty)}
              sx={STYLES.problemTags}
            />
          </Stack>
          <Stack direction={"row"}>
            {userData ? (
              <Stack direction={"row"} gap={2} alignItems={"center"}>
                <AiButtonUI onClick={onOpenPanel} />
                <ProblemTimerUI
                  startTime={questionData.startTime}
                  endTime={questionData.postSubmit?.endTime}
                />
              </Stack>
            ) : (
              <LoginSignupStack />
            )}
          </Stack>
        </Stack>
      </Box>
      <Box height={12} />
      <Typography variant="h6" fontWeight={700}>
        {questionData.title}
      </Typography>
      <Box height={12} />
      <Typography variant="body1">
        {htmlToReactParser.parse(questionData.description)}
      </Typography>
      <Box height={24} />
      <UserInputUI />
      <Box height={12} />
    </Stack>
  );
}
